import { render, staticRenderFns } from "./ProviderIcon.vue?vue&type=template&id=7223dda3&"
import script from "./ProviderIcon.vue?vue&type=script&lang=js&"
export * from "./ProviderIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports